import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/main.header.component';

class Design2 extends Component {
  render() {
    return (
      <div className="Design">
        <Header
          props={this.props}
        />
        <div className="design-body">
          <div id="design-text-links">
            <Link to='/design/divercity' style={{ textDecoration: 'none'}}>
              <div id="design-text">
                  Divercity
                <div id="design-thumbs-text">
                  Built out entire Front-End Application for Divercity.io using React + Redux
                </div>
              </div>
            </Link>
            <Link to='/design/shade' style={{ textDecoration: 'none'}}>
              <div id="design-text">
                  Shade
                <div id="design-thumbs-text">
                  a social video platform for iOS built with React-Native, using AWS for storage.
                </div>
              </div>
            </Link>

            <Link to='/design/flickr' style={{ textDecoration: 'none' }}>
              <div id="design-text">
                  Flickr Grid
                <div id="design-thumbs-text">
                  was built accessing Flickr's public search API to create a responsive image-grid gallery.
              </div>
              </div>
            </Link>

            <Link to='/design/jnkr' style={{ textDecoration: 'none' }}>
              <div id="design-text">
                .JNKR
                <div id="design-thumbs-text">
                  a custom built Content Management System (CMS) designed to be a better Craigslist.
                </div>
              </div>
            </Link>

            <Link to='/design/truisms' style={{ textDecoration: 'none'}}>
              <div id="design-text">
                  Truisms
                <div id="design-thumbs-text">
                  an Extension that gives a randomized pastel color combined with a Jenny Holzer Truism.
                </div>
              </div>
            </Link>

            <Link to='/design/todo' style={{ textDecoration: 'none'}}>
              <div id="design-text">
                  To-Do List
                <div id="design-thumbs-text">
                  a Single Page Application (SPA) To-Do list designed around utilizing the Futura font.
              </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}


export default (Design2);